import {omit} from 'lodash';
import {Environment, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import * as tracking from '../../tracking';
import {
	CreateCustomFieldDefinitionInput,
	CreateCustomFieldDefinitionMutation,
} from './__generated__/CreateCustomFieldDefinitionMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';
import {trackAndCommitMutation} from '../../tracking/amplitude/TrackMutation';
import type {DeclarativeMutationConfig, Disposable} from 'relay-runtime';

// We pass the companyId in the input to be able to use it in the configs.
// Is there a better way to do this?
type CreateCustomFieldDefinitionConfig = {
	companyId: string;
};

const mutation = graphql`
	mutation CreateCustomFieldDefinitionMutation($input: CreateCustomFieldDefinitionInput!) {
		createCustomFieldDefinition(input: $input) {
			customFieldDefinition {
				node {
					id
					key
					displayName
					readOnly
					entityType
					avaRef
					type
				}
			}
		}
	}
`;

function getConfigs(input: CreateCustomFieldDefinitionConfig): DeclarativeMutationConfig[] {
	return [
		{
			type: 'RANGE_ADD',
			parentID: input.companyId,
			connectionInfo: [
				{
					key: 'Company_customFieldDefinitionsV2',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'customFieldDefinition',
		},
	];
}

function getOptimisticResponse(input: CreateCustomFieldDefinitionInput) {
	return {
		createCustomFieldDefinition: {
			customFieldDefinition: {
				node: {
					id: undefined,
					key: input.key,
					displayName: input.displayName,
					readOnly: input.readOnly,
					entityType: input.entityType,
					type: input.type,
					avaRef: input.avaRef,
				},
			},
		},
	};
}
function commit(
	environment: Environment,
	input: MutationInput<CreateCustomFieldDefinitionInput & CreateCustomFieldDefinitionConfig>,
	onSuccess: RelayOnCompleted<CreateCustomFieldDefinitionMutation>,
	onError: RelayOnError
): Disposable {
	tracking.trackEvent('CustomFieldDefinition - Created');

	const cleanedInput = omit(input, ['companyId']);

	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...cleanedInput}},
		configs: getConfigs(input),
		optimisticResponse: getOptimisticResponse(cleanedInput),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
